import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Helmet } from 'react-helmet';
import EmptyList from '../components/EmptyList';
import { RecentEventsData } from '../data/RecentEventsData'

const RecentUpdatesDetails = () => {
    const { RecentEventName } = useParams();
    const [RecentEvent, setRecentEvent] = useState(null);
    useEffect(() => {
        let RecentEvent = RecentEventsData.find((RecentEvent) => RecentEvent.RecentEventName === (RecentEventName));
        if (RecentEvent) {
            setRecentEvent(RecentEvent);
        }
    }, [RecentEventName]);
    return (
        <div className='main-container'>
            {RecentEvent ? (
                <div>
                    <Helmet>
                        <title>Events | {RecentEvent.RecentEventName}</title>
                    </Helmet>

                    <div className="section">
                        <div className="section-heading">
                            <h1>{RecentEvent.RecentEventName}</h1>
                        </div>
                        <div className="events-detalis">
                        <img src={RecentEvent.Image} alt='' />

                        </div>
                        
                    </div>
                </div>



            ) : (
                <EmptyList />
            )}
        </div>
    )
}

export default RecentUpdatesDetails